module.exports = __webpack_public_path__ + "img/189.e474f97b.jpg";